"use client";

import OnScrollComponent from "component/on-scroll-component/OnScrollComponent";
import { useRef } from "react";
import styles from "./fullwidthSection.module.scss";
import HomepageValueProp from "./homepage-value-props.component";

function FullWidthSection() {
  const fullWidthSectionRef = useRef();

  return (
    <>
      <div className={styles.full_width_container}>
        <OnScrollComponent ref={fullWidthSectionRef} visibleIfRefIsInViewPort onlyOneTime>

          <div className={`section ${styles.section}`} style={{ background: "rgb(255, 255, 255)" }}>
            <div className="d-flex align-items-center justify-content-center">
              <HomepageValueProp />
            </div>
          </div>

        </OnScrollComponent>
      </div>
      <div ref={fullWidthSectionRef} />
    </>
  );
}

export default FullWidthSection;
